export default "__VITE_ASSET__B0yCXv1n__"